import { useCallback } from 'react'

import useBlickPlusOnboardingCurrentStep from '@hooks/useBlickPlusOnboardingCurrentStep'
import useBlickPlusOnboardingStepsABTest from '@hooks/useBlickPlusOnboardingStepsABTest'
import useTracking, { TrackingFnType } from '@hooks/useTracking'

type BlickPlusOnboardingTrackingParams = {
  buttonText?: string
  element: string
  targetUrl?: string
}

const useBlickPlusOnboardingTracking = () => {
  const initialSteps = useBlickPlusOnboardingStepsABTest()

  const currentStepIndex = useBlickPlusOnboardingCurrentStep()
  const trackingOnCloseCallback = useCallback<
    TrackingFnType<Pick<BlickPlusOnboardingTrackingParams, 'buttonText'>>
  >(
    ({ extraData }) => ({
      event: 'onboarding_click_close',
      element: 'close',
      button_text: extraData.buttonText,
      element_status: `onboarding_${initialSteps?.[currentStepIndex]}`,
      element_state: currentStepIndex + 1,
    }),
    [initialSteps, currentStepIndex],
  )

  const trackingOnClickCallback = useCallback<
    TrackingFnType<BlickPlusOnboardingTrackingParams>
  >(
    ({ extraData }) => ({
      event: 'onboarding_click',
      element: extraData.element,
      element_status: `onboarding_${initialSteps?.[currentStepIndex]}`,
      element_state: currentStepIndex + 1,
      ...(extraData.buttonText ? { button_text: extraData.buttonText } : {}),
      ...(extraData.targetUrl ? { target_url: extraData.targetUrl } : {}),
    }),
    [initialSteps, currentStepIndex],
  )

  const trackingOnImpressionCallback = useCallback<TrackingFnType>(
    () => ({
      event: 'onboarding_impression',
      element_status: `onboarding_${initialSteps?.[currentStepIndex]}`,
      element_state: currentStepIndex + 1,
    }),
    [initialSteps, currentStepIndex],
  )

  const trackOnClose = useTracking(trackingOnCloseCallback)
  const trackOnClick = useTracking(trackingOnClickCallback)
  const trackOnImpression = useTracking(trackingOnImpressionCallback)
  return {
    trackOnClose,
    trackOnClick,
    trackOnImpression,
  }
}

export default useBlickPlusOnboardingTracking
